import { SET_EDITED } from "../actions/edited";

export default (state = false, { type, payload }) => {
  switch (type) {
    case SET_EDITED:
      return payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/edited.js